module.exports = __webpack_public_path__ + "static/media/right-arrow-last-hover.05336536.svg";